import { merge } from '../../../helper';
import * as exElement from '../../../utils/element';

import alreadyTableBody from '../utils/alreadyTableBody';
import type { TypeTableRowsCountConfig } from '../types';

// ----------------------------------------------------------------------------

function count(element: HTMLElement, config: TypeTableRowsCountConfig = {}): any[] {
    if (!(element instanceof HTMLTableElement)) {
        console.error('Is not an element table...');
        return [];
    }

    const defConfig: Record<string, any> = {
        columnCount: 0,
        rowCount: 0,
        tbody: {},
    };

    merge(defConfig, config);

    const elTableBody = alreadyTableBody(element, defConfig.tbody);
    const rows: any[] = [];

    for (let r = 0; r < defConfig.rowCount; r++) {
        let elRow = elTableBody.rows[r];

        if (!elRow || defConfig.already !== true) {
            elRow = exElement.create({
                merge: defConfig.tbody.row,
                tag: 'tr',
            }) as HTMLTableRowElement;
            elTableBody.appendChild(elRow);
        }

        if (r % 2 == 0) {
            elRow.addClass('odd');
            elRow.removeClass('even');
        } else {
            elRow.addClass('even');
            elRow.removeClass('odd');
        }

        if (typeof defConfig.fnAddedRow === 'function') {
            defConfig.fnAddedRow.call(elRow, {
                element: elRow,
                rowIndex: r,
            });
        }

        const columns: any[] = [];

        for (let c = 0; c < defConfig.columnCount; c++) {
            let elColumn = elRow.cells[c];

            if (!elColumn || defConfig.already !== true) {
                elColumn = exElement.create({
                    merge: defConfig.tbody.cell,
                    tag: 'td',
                }) as HTMLTableCellElement;
                elRow.appendChild(elColumn);
            }

            if (typeof defConfig.fnAddedColumn === 'function') {
                defConfig.fnAddedColumn.call(elColumn, {
                    element: elColumn,
                    rowIndex: r,
                    columnIndex: c,
                });
            }

            columns.push(elColumn);
        }

        rows.push({
            row: elRow,
            columns: columns,
        });
    }

    return rows;
}

// ----------------------------------------------------------------------------

export { count };
